import React from "react";
import "../../styles/home.css";
import { Helmet } from "react-helmet-async";
import { TbDrone } from "react-icons/tb";


import { PiStudentBold } from "react-icons/pi";
import { RiFundsBoxLine } from "react-icons/ri";
import { FaChildReaching } from "react-icons/fa6";
import { MdOutlineCorporateFare } from "react-icons/md";
import { FaGraduationCap } from "react-icons/fa";
import { FaChildren } from "react-icons/fa6";
import { BiSolidInstitution } from "react-icons/bi";
import { FaCity } from "react-icons/fa";

import { IoSchool } from "react-icons/io5";
import { IoPodium } from "react-icons/io5";
import { IoAccessibility } from "react-icons/io5";
import { IoAnalytics } from "react-icons/io5";
import { IoRibbon } from "react-icons/io5";
import { IoRocketSharp } from "react-icons/io5";
import { IoHeartSharp } from "react-icons/io5";
import { IoGolf } from "react-icons/io5";


const HOME_EVENTS = [
  {
    id: "e1",
    title: "Drone Tech Workshop & Expo 2025 ",
    description:
      "Hon’ble CM Dr. Mohan Yadav tested and appreciated our programmable drone technology ",
    mediaType: "video",                      // "image" or "video"
    media: "/review_videos/MP_DroneTech_Workshop_CM.mp4",      // or a .mp4 path
    pt:"/review_videos/PT_CM.jpeg",
    objectPosition: "50% 15%",   // <-- add this
    logo: "/logos/MP_sasan_logo.png",   // small logo
    logoName: "MPCST, MPSEDC, IIT Indore",
  },
  {
    title: "Program Highlights",
    description:
      "Learn to assemble and understand the core components of a drone in this hands-on workshop.",
    longDescription: "abc",
    mediaType: "video",
    media: "/review_videos/PH_Beacon_school.mp4",
    pt:"/review_videos/PT_TBS.png",
    logo: "/logos/logo_tbs.jpg",
    logoName: "The Beacon School, Gurugoan",
  },
  {
    id: "e3",
    title: "Drone Workshop",
    description:
      "Explore how AI and ML are revolutionising drone capabilities and autonomy.",
    longDescription: "abc",
    mediaType: "video",
    media: "/review_videos/Workshop_RN_Podar.mp4",
    pt:"/review_videos/PT_RN.png",
    logo: "/logos/R.N_Podar_School_Logo.png",
    logoName: "R.N. Podar School, Mumbai",
  }
];


export default function Home() {
  return (
    <>
    <Helmet>
  <title>PracVerse – Drone Education & STEM Learning for Schools, Colleges & NGOs</title>
  <link rel="icon" href="/favicon.ico" />
<link rel="shortcut icon" href="/favicon.ico" />
<link rel="apple-touch-icon" href="/favicon.ico" />

  <meta
    name="description"
    content="PracVerse offers practical drone education, AI, coding and STEM learning programs for schools, colleges, NGOs and corporates using hands-on drones and real-world projects."
  />
  <link rel="canonical" href="https://www.pracverse.com/" />

  {/* Open Graph */}
  <meta property="og:title" content="PracVerse – Drone Education & STEM Learning" />
  <meta
    property="og:description"
    content="Drone courses, STEM workshops, CSR programs and future-tech learning for students across India."
  />
  <meta property="og:url" content="https://www.pracverse.com/" />
  <meta property="og:image" content="https://www.pracverse.com/images/og-home.jpg" />

  {/* JSON-LD Home as WebPage */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": "https://www.pracverse.com/#webpage",
      "url": "https://www.pracverse.com/",
      "name": "PracVerse – Drone Education & STEM Learning",
      "description":
        "PracVerse provides drone education and STEM learning programs with hands-on drones, AI and coding for schools, colleges, NGOs and corporates.",
      "publisher": {
        "@type": "Organization",
        "name": "PracVerse",
        "url": "https://www.pracverse.com"
      }
    })}
  </script>
</Helmet>




    <div className="page-root">
      <main className="home-main">
        {/* HERO */}
          <div className="container">

        <section className="hero grid">
          {/* <div className="container"> */}
            <div className="hero-content">
              <p className="eyebrow">Innovative Drone Education</p>
              <h1 className="hero-title">The Future of STEM Learning Takes Flight</h1>
              <p className="hero-desc">
                Hands-on drone programs combining building, programming, AI and aerial
                skills for students across grades.
              </p>
              <div className="hero-ctas">
                <a className="btn primary" href="/courses">Explore Courses</a>
                <a className="btn outline" href="/partnerships">Partner With Us</a>
              </div>
            </div>

            <div className="hero-media">
              <div className="media-card">
                <img src="/images/home1.png" alt="Students learning drones" />
              </div>
            </div>
          {/* </div> */}
        </section>
          </div>



{/* PARTNERSHIP REVIEW */}
        <section className="partnerships-preview section" aria-labelledby="partners-heading">
          <div className="container">
        <div className="partners-grid container-grid">
            <div className="partners-left">
            <h2 >Educational Partnerships That Transform Learning</h2>

            <h3>
                We collaborate with schools, colleges, NGOs and corporates to bring cutting-edge drone education to students everywhere.
                Our programs are designed to integrate seamlessly with existing curricula and can be funded through CSR initiatives.
            </h3>

            <ul className="partners-features" aria-hidden="false">
                <li className="partners-feature">
                {/* <div className="feature-icon" aria-hidden="true">👥</div> */}
                {/* <FaChildReaching size={25}/> */}
                <IoAccessibility size={25}/> 
                <div className="feature-text">School Partnerships</div>
                </li>

                <li className="partners-feature">
                {/* <div className="feature-icon" aria-hidden="true">💰</div> */}
                {/* <RiFundsBoxLine size={25}/> */}
                <IoAnalytics size={25}/>
                <div className="feature-text">CSR Funding</div>
                </li>

                <li className="partners-feature">
                {/* <div className="feature-icon" aria-hidden="true">🧭</div> */}
                {/* <PiStudentBold size={25} /> */}
                <IoSchool size={25}/>
                <div className="feature-text">College Partnerships</div>
                </li>

                <li className="partners-feature">
                {/* <div className="feature-icon" aria-hidden="true">📚</div> */}
                {/* <MdOutlineCorporateFare size={25}/> */}
                <IoPodium size={25}/>
                <div className="feature-text">Corporate Engagement</div>
                </li>
            </ul>

            <div style={{ marginTop: 18 }}>
                <a className="btn primary" href="/partnerships">Learn More</a>
            </div>
            </div>

            <div className="partners-right">
            <div className="partners-hero-media">
                <img src="/images/home_partnership.png" alt="Educational partnership meeting" />
            </div>
            </div>
        </div>
        </div>
        </section>



        {/* ================= HOME PAGE – EVENTS PREVIEW ================= */}
<section className="home-events-section">
  <div className="container home-events-inner">

    <header className="home-events-header">
      <h2>Events & Workshops</h2>
      <h3>Explore glimpses from our drone education workshops and programs.</h3>
    </header>

    <div className="home-events-grid">
      {HOME_EVENTS.map((ev) => (
        <article className="home-event-card" key={ev.id}>

          {/* MEDIA */}
          <div className="home-event-media">
            {ev.mediaType === "video" ? (
              <video
                className="home-event-video"
                src={ev.media}
                // autoPlay
                // loop
                muted
                controls
                playsInline
                style={{
    objectPosition: ev.objectPosition || "50% 50%", 
  }}
                poster={ev.pt}
              />
            ) : (
              <img className="home-event-image" src={ev.media} alt={ev.title} />
            )}
          </div>

          {/* CONTENT */}
          <div className="home-event-body">
            <h3 className="home-event-title">{ev.title}</h3>
            <p className="home-event-desc">{ev.description}</p>

            <div className="home-event-meta">
              {ev.logo && <img src={ev.logo} className="home-event-logo" alt={ev.logoName} />}
              {ev.logoName && <span className="home-event-logoName">{ev.logoName}</span>}
            </div>
          </div>

        </article>
      ))}
    </div>

    <div className="home-events-cta">
      <a className="btn primary" href="/events">View All Events</a>
    </div>

  </div>
</section>

        






{/* COMPREHENSIVE LEARNING EXPERIENCE */}
<section className="learning-section">
  <div className="container learning-inner">
    {/* Heading + subtitle */}
    <header className="learning-header">
      <h2>Comprehensive Learning Experience</h2>
      <h3 className="learning-subtitle">
        Our integrated approach combines theoretical knowledge with practical skills across multiple disciplines
      </h3>
    </header>

    {/* 3 feature cards */}
    <div className="learning-grid">
      {/* Build & Fly */}
      <article className="learning-card">
        <div className="learning-icon-wrap">
          {/* airplane icon */}
          <svg
  className="learning-icon"
  viewBox="0 0 24 24"
  aria-hidden="true"
>
  <g
    fill="none"
    stroke="#141a3b"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Central body */}
    <circle cx="12" cy="12" r="2.2" />

    {/* Arms */}
    <line x1="8" y1="8" x2="10.5" y2="10.5" />
    <line x1="16" y1="8" x2="13.5" y2="10.5" />
    <line x1="8" y1="16" x2="10.5" y2="13.5" />
    <line x1="16" y1="16" x2="13.5" y2="13.5" />

    {/* Propeller circles */}
    <circle cx="6.5" cy="6.5" r="2.1" />
    <circle cx="17.5" cy="6.5" r="2.1" />
    <circle cx="6.5" cy="17.5" r="2.1" />
    <circle cx="17.5" cy="17.5" r="2.1" />
  </g>
</svg>

        </div>
        <h3 className="learning-card-title">Build &amp; Fly</h3>
        <p className="learning-card-text">
          Hands-on construction and piloting experience with professional-grade
          equipment and safety protocols
        </p>
      </article>

      {/* Program & Code */}
      <article className="learning-card">
        <div className="learning-icon-wrap learning-icon-wrap--highlight">
          {/* code brackets icon */}
          <svg
            className="learning-icon"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path
              d="M9 7L5 12l4 5M15 7l4 5-4 5"
              fill="none"
              stroke="#141a3b"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <h3 className="learning-card-title">Program &amp; Code</h3>
        <p className="learning-card-text">
          Block-based programming and AI/ML concepts tailored for autonomous
          flight and intelligent systems
        </p>
      </article>

      {/* Create & Film */}
      <article className="learning-card">
        <div className="learning-icon-wrap">
          {/* camera icon */}
          <svg
            className="learning-icon"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <rect
              x="4"
              y="7"
              width="16"
              height="11"
              rx="2"
              ry="2"
              fill="none"
              stroke="#141a3b"
              strokeWidth="1.6"
            />
            <path
              d="M9 7l1.2-2h3.6L15 7"
              fill="none"
              stroke="#141a3b"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle
              cx="12"
              cy="12.5"
              r="2.5"
              fill="none"
              stroke="#141a3b"
              strokeWidth="1.6"
            />
          </svg>
        </div>
        <h3 className="learning-card-title">Create &amp; Film</h3>
        <p className="learning-card-text">
          Professional videography and cinematography techniques using
          aerial perspectives and creative storytelling
        </p>
      </article>
    </div>
  </div>
</section>






{/* COURSES PREVIEW (featured) */}
<section
  className="featured-courses section"
  aria-labelledby="featured-courses-heading"
>
  <div className="container">
    <header
      className="featured-header"
      style={{ textAlign: "center", marginBottom: 20 }}
    >
      <h2>Featured Courses</h2>
      <p className="courses-hero-sub" style={{ maxWidth: 840, margin: "0 auto" }}>
        Discover our most popular drone education programs, from year-long
        school integrations to specialised college-level tracks.
      </p>
    </header>

    <div className="featured-grid">

      <article className="course-card home-course-card">
        <div className="course-media">
          <img
            src="/courses_images/School_short1.png"
            alt="Short-Term Curriculum Integration"
          />
        </div>

        <div className="course-body">
          <div className="course-header-row">
            <h4 className="course-title">
              Short-Term Curriculum Integration
            </h4>
            <span className="level-pill school">School</span>
          </div>

          <p className="course-desc">
            A 2–3 months in-school module conducted during activity periods. Cove
            <a href="/courses"> …Read more</a>
          </p>

          <div className="course-stats">
            <span className="stat">⏱ 16h</span>
            <span className="stat">👥 School Students</span>
            <span className="tag-pill">1–2 times/week</span>
          </div>

          <div className="course-actions">
            <a href="/courses" className="btn view-details">
              View Details
            </a>
          </div>
        </div>
      </article>


        <article className="course-card home-course-card">
        <div className="course-media">
          <img
            src="/courses_images/Drone_eng.png"
            alt="Drone Engineering & Aeronautical Systems"
          />
        </div>

        <div className="course-body">
          <div className="course-header-row">
            <h4 className="course-title">
              Drone Engineering &amp; Aeronautical Systems
            </h4>
            <span className="level-pill college">College</span>
          </div>

          <p className="course-desc">
            A comprehensive engineering-focused program covering the design, construc
            <a href="/courses"> …Read more</a>
          </p>

          <div className="course-stats">
            <span className="stat">⏱ 15h</span>
            <span className="stat">👥 College Students</span>
            <span className="tag-pill">2–3 times/week</span>
          </div>

          <div className="course-actions">
            <a href="/courses" className="btn view-details">
              View Details
            </a>
          </div>
        </div>
      </article>



      <article className="course-card home-course-card">
        <div className="course-media">
          <img
            src="/courses_images/NGO_skill.jpg"
            alt="Drone Skill Development Program"
          />
        </div>

        <div className="course-body">
          <div className="course-header-row">
            <h4 className="course-title">Drone Skill Development Program</h4>
            <span className="level-pill school">NGO</span>
          </div>

          <p className="course-desc">
            A structured, beginner-friendly skill-building program for age
            <a href="/courses"> …Read more</a>
          </p>

          <div className="course-stats">
            <span className="stat">⏱ 16h</span>
            <span className="stat">👥 School & College Students</span>
            <span className="tag-pill">2-3 times/week</span>
          </div>

          <div className="course-actions">
            <a href="/courses" className="btn view-details">
              View Details
            </a>
          </div>
        </div>
      </article>
      
    </div>

    <div
      style={{ display: "flex", justifyContent: "center", marginTop: 22 }}
    >
      <a className="btn primary" href="/courses">
        View All Courses
      </a>
    </div>
  </div>
</section>







        {/* ABOUT PREVIEW */}
        <section className="about-preview section" aria-labelledby="about-preview-heading">
          <div className="container">
        <div className="about-preview-inner container-grid">
            <div className="about-left">
            <h2>Pioneering the Future of Drone Education</h2>
            <h3>
                We're on a mission to democratize access to emerging drone technology,
                empowering students across different age groups with the skills needed for tomorrow's careers.
            </h3>

            <div className="mission-card" role="region" aria-label="Our mission">
                <div className="mission-icon" aria-hidden="true">
                {/* simple target icon SVG */}
                <svg width="38" height="38" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="9" stroke="#6B62A7" strokeWidth="1.5" opacity="0.12"/>
                    <circle cx="12" cy="12" r="5" stroke="#6B62A7" strokeWidth="1.6"/>
                    <circle cx="12" cy="12" r="2" fill="#6B62A7"/>
                </svg>
                </div>
                <div className="mission-body">
                <h3>Our Mission</h3>
                <p>To revolutionize STEM education by providing comprehensive, accessible, and innovative drone technology programs that prepare students for the rapidly evolving technological landscape.</p>
                </div>
            </div>

            <ul className="about-stats-list" aria-hidden="false">
                <li className="stat-item">
                {/* <div className="stat-icon">👥</div> */}
                {/* <FaChildren size={32}/> */}
                <IoRibbon size={25}/>
                <div className="stat-text"><strong>10,000+</strong><div className="stat-sub">Students Educated</div></div>
                </li>
                <li className="stat-item">
                {/* <div className="stat-icon">🏫</div> */}
                {/* <BiSolidInstitution size={32}/> */}
                <IoRocketSharp size={25}/>
                <div className="stat-text"><strong>45+</strong><div className="stat-sub">Partner Institutions</div></div>
                </li>
                <li className="stat-item">
                {/* <div className="stat-icon">🧰</div> */}
                {/* <FaCity size={32}/> */}
                <IoGolf size={25}/>
                <div className="stat-text"><strong>10+</strong><div className="stat-sub">Cities Reached</div></div>
                </li>
                <li className="stat-item">
                {/* <div className="stat-icon">🎓</div> */}
                {/* <FaGraduationCap size={32}/> */}
                <IoHeartSharp size={25}/>
                <div className="stat-text"><strong>100%</strong><div className="stat-sub">Student Satisfaction</div></div>
                </li>
            </ul>

            <div style={{ marginTop: 18 }}>
                <a className="btn primary" href="/about">Learn More About Us</a>
            </div>
            </div>

            <div className="about-right">
            <div className="about-hero-media">
                <img src="/images/home_about.png" alt="Students working with a drone" />
            </div>
            </div>
        </div>
        </div>
        </section>





        {/* TESTIMONIALS */}
<section className="testimonials-preview large-preview" aria-labelledby="home-testimonials-heading">
  <div className="container">
    <header className="home-test-header" style={{ textAlign: "center", marginBottom: 18 }}>
      <h2>Hear From Our Community</h2>
      <h3>Watch short video testimonials from school principals and students who have experienced our drone programs.</h3>
    </header>











<div className="home-test-grid">
            <article className="home-test-card">
              <div className="home-video-area">
                {/* <div className="home-video-badge">▶ Video Testimonial</div> */}

                <div className="home-video-placeholder">
                  <video
                    controls
                    playsInline
                    preload="metadata"
                    // poster="/videos/principal-1-poster.jpg"
                    poster="/review_videos/mvj_pt_cover.png"
                  >
                    {/* <source src="/videos/principal-1.mp4" type="video/mp4" /> */}
                    <source src="/review_videos/MVJ_Bangalore.mp4" type="video/mp4" />

                    {/* <source src="/videos/principal-1.webm" type="video/webm" /> */}
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>

              <div className="home-test-meta">
                <div className="meta-left">
                  <img className="avatar" src="/logos/MVJ_logo.png" alt="MVJ" />
                  <div>
                    <div className="meta-name">Mrs. Vamsheepriya Amar</div>
                    <div className="meta-role">Pricipal, MVJ International School, Bangalore</div>
                  </div>
                </div>

                <div className="meta-quote">“A Grade 2 child confidently used scientific terms like lift and drag — concepts usually taught in higher classes — just through the drone sessions...”</div>
              </div>
            </article>



            <article className="home-test-card">
              <div className="home-video-area">
                {/* <div className="home-video-badge">▶ Video Testimonial</div> */}

                <div className="home-video-placeholder">
                  <video
                    controls
                    playsInline
                    preload="metadata"
                    poster="/review_videos/bps_ana_pt.png"
                  >
                    <source src="/review_videos/BPS_Akshra_and_Ananya.mp4" type="video/mp4" />
                    {/* <source src="/videos/principal-1.webm" type="video/webm" /> */}
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>

              <div className="home-test-meta">
                <div className="meta-left">
                  <img className="avatar" src="/logos/logo_bps.jpeg" alt="BPS" />
                  <div>
                    <div className="meta-name">Akshra and Ananya</div>
                    <div className="meta-role">Students, Bharti Public School, Delhi</div>
                  </div>
                </div>

                <div className="meta-quote">“The drone workshop was an immersive experience — the physical flying, the crashes, and the memories made it unforgettable...”</div>
              </div>
            </article>


          </div>











    <div className="home-test-cta" style={{ display: "flex", justifyContent: "center", marginTop: 22 }}>
      <a className="btn primary" href="/testimonials">View All Testimonials</a>
    </div>
  </div>
</section>

      </main>
    </div>

    </>
  );
}
